import { HackerJudgingStatus } from "src/api/types.generated";

/**
 * `eventAttendees` is organizer-only, so hackers detect a missing profile from
 * `myJudgingInfo`: loaded, no badgeCode, and not already classified as
 * NO_BADGE_CODE (that status means a profile exists but badge lookup failed).
 */
export const isMissingHackerEventAttendee = (
  judgingInfo:
    | { badgeCode?: string | null; status?: HackerJudgingStatus }
    | null
    | undefined,
  hasLoadedData: boolean
): boolean =>
  hasLoadedData &&
  !judgingInfo?.badgeCode &&
  judgingInfo?.status !== HackerJudgingStatus.NoBadgeCode;
